/* eslint-disable no-unused-vars */
import React from 'react';
import { FlappyBird } from 'kards-components';

export default () => <FlappyBird edit />;
